export const quizTranslations = {
  en: {
    test: 'Test',
    ready: 'Ready to start the test?',
    startTest: 'Start Test',
    loading: 'Loading questions...',
    question: 'Question',
    of: 'of',
    quizInstructions: 'Select the best answer for each question. Click on an option to answer and move to the next question.',
    reviewInstructions: 'Review mode: You can now navigate between answered questions. Click question numbers to review your answers.',
    timeInstructions: 'Take your time to read each question carefully. Your time spent on each question is tracked to help analyze your performance.',
    navigationInstructions: 'Use the navigation panel on the right to track your progress and move between questions. Submit when you\'re ready.',
    confirmSubmit: 'Confirm Submission',
    confirmText: 'Are you sure you want to submit your quiz?',
    answered: 'Answered',
    unanswered: 'Unanswered',
    review: 'Review Answers',
    submit: 'Submit',
    cancel: 'Cancel',
    previous: 'Previous',
    next: 'Next',
    questionsOverview: 'Questions Overview'
  },
  vi: {
    test: 'Bài kiểm tra',
    ready: 'Chuẩn bị sẵn sàng để bắt đầu bài kiểm tra?',
    startTest: 'Bắt đầu bài kiểm tra',
    loading: 'Đang tải câu hỏi...',
    question: 'Câu hỏi',
    of: '/',
    quizInstructions: 'Chọn câu trả lời đúng nhất cho mỗi câu hỏi. Nhấp vào một lựa chọn để trả lời và chuyển sang câu tiếp theo.',
    reviewInstructions: 'Chế độ xem lại: Bạn có thể di chuyển giữa các câu hỏi đã trả lời. Nhấp vào số câu hỏi để xem lại câu trả lời của bạn.',
    timeInstructions: 'Hãy dành thời gian đọc kỹ từng câu hỏi. Thời gian bạn dành cho mỗi câu được ghi lại để giúp phân tích hiệu suất của bạn.',
    navigationInstructions: 'Sử dụng bảng điều khiển bên phải để theo dõi tiến độ và di chuyển giữa các câu hỏi. Nhấn nộp bài khi bạn đã sẵn sàng.',
    confirmSubmit: 'Xác nhận nộp bài',
    confirmText: 'Bạn có chắc chắn muốn nộp bài?',
    answered: 'Đã trả lời',
    unanswered: 'Chưa trả lời',
    review: 'Xem lại bài làm',
    submit: 'Nộp bài',
    cancel: 'Hủy',
    previous: 'Trước',
    next: 'Tiếp',
    questionsOverview: 'Tổng quan câu hỏi'
  }
};